export default __webpack_public_path__ + "static/media/24-icon-checked.02cfa027.svg";